import React, { useState, useEffect, useContext } from 'react';
import context from '../context/recipesContext';
import { getFoodsByCategory } from '../services/getFoodsByCategory';

const getCategories = async () => {
  const maxSize = 5;
  const request = await fetch('https://www.themealdb.com/api/json/v1/1/list.php?c=list');
  const response = await request.json();
  return response.meals.slice(0, maxSize);
};

function FiltersFoods() {
  const [categories, setCategories] = useState([]);
  const [currFilter, setCurrFilter] = useState('');
  const { setFilterFoods, filterFoods, setFoods } = useContext(context);

  useEffect(() => {
    getCategories().then((data) => (setCategories(data)));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getRecipes = async ({ target }) => {
    if (currFilter === target.id) {
      setFilterFoods({ ...filterFoods, filter: 'name' });
      setCurrFilter('');
    } else {
      setCurrFilter(target.id);
      setFoods(await getFoodsByCategory(target.id));
    }
  };

  return (
    <div className="categories">
      <button
        data-testid="All-category-filter"
        className="category-btn"
        type="button"
        onClick={ () => {
          setFilterFoods({ filter: 'name', value: '' });
          setCurrFilter('');
        } }
      >
        All
      </button>
      {
        categories && (
          categories.map((category, index) => (
            <button
              id={ category.strCategory }
              key={ index }
              type="button"
              className="category-btn"
              data-testid={ `${category.strCategory}-category-filter` }
              onClick={ getRecipes }
            >
              {category.strCategory}
            </button>))
        )
      }
    </div>
  );
}

export default FiltersFoods;
